import { render, staticRenderFns } from "./TableEmptyStateNoResult.vue?vue&type=template&id=8b90edb0&"
import script from "./TableEmptyStateNoResult.vue?vue&type=script&lang=js&"
export * from "./TableEmptyStateNoResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports